<h2 mat-dialog-title class="admin-subheader">Warnung</h2>
<mat-dialog-content>
    <p class="admin-text">Zu der Gruppe <strong>{{ data.displayName }}</strong> gehören die folgenden Seiten:</p>
    <ul class="admin-text">
        @for(pageName of data.filteredPagesNames; track pageName) {
            <li><strong>{{ pageName }}</strong></li>
        }
    </ul>
    <p class="admin-text">Möchten Sie diese Gruppe wirklich löschen?</p>
    <app-website-config-form-expansion-panel [title]="'Was passiert wenn ich die Gruppe lösche?'" [noMargin]="true" >
        <p class="admin-text">Wenn Sie die Gruppe löschen, wird die Gruppe sowie alle Seiten dieser Gruppe nicht mehr in der Navigationsleiste angezeigt.
        </p>
        <p class="admin-text">Alle Seiten die zu dieser Gruppe gehören, bleiben erhalten und können weiterhin aufgerufen werden.
        </p>
    </app-website-config-form-expansion-panel>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="onCancel()">Abbrechen</button>
    <button mat-button (click)="onDelete()" cdkFocusInitial>Löschen</button>
</mat-dialog-actions>